// removed by extract-text-webpack-plugin
module.exports = {"HeaderBackButton":"HeaderBackButton---30BAe"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/nav/Header/HeaderBackButton/style.styl
// module id = cCgd
// module chunks = 89